// src/components/examples/SimpleTest.js
import React from 'react';

const SimpleTest = () => {
  console.log('SimpleTest component loaded!');
  
  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-3xl font-bold text-green-600 mb-4">✅ Simple Test Page</h1>
      <p className="text-lg text-gray-700">
        If you can see this, the routing is working! The issue might be with the VideoUploadExample component.
      </p>
      <div className="mt-4 p-4 bg-green-50 border border-green-200 rounded-lg">
        <h2 className="font-semibold text-green-800 mb-2">Debug Info:</h2>
        <p className="text-sm text-green-700">Current URL: {window.location.href}</p>
        <p className="text-sm text-green-700">Path: {window.location.pathname}</p>
        <p className="text-sm text-green-700">Component: SimpleTest</p>
      </div>
    </div>
  );
};

export default SimpleTest; 